// source: starlord/messages/models/authentication_protocol_enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.AuthenticationProtocol', null, global);
/**
 * @enum {number}
 */
proto.AuthenticationProtocol = {
  OAUTH: 0,
  SAML: 1
};

goog.object.extend(exports, proto);
